import { Component, input } from '@angular/core';

@Component({
  selector: 'vx-locker-status-card',
  standalone: true,
  template: `
    <article class="locker card">
      <div>
        <h3>{{ nome() }}</h3>
        <p>{{ citta() }} / {{ posizione() }}</p>
      </div>
      <span class="status" [class]="stato()">{{ stato() }}</span>
    </article>
  `,
  styles: [`
    .locker {
      display: flex;
      justify-content: space-between;
      gap: 12px;
      align-items: start;
      padding: 16px;
    }
    h3 { margin: 0 0 6px; font-family: "Space Grotesk"; font-size: 1rem; }
    p { margin: 0; color: var(--vx-muted); font-size: .9rem; }
  `]
})
export class LockerStatusCardComponent {
  nome = input.required<string>();
  citta = input.required<string>();
  posizione = input.required<string>();
  stato = input.required<string>();
}
